<div class="boxWhite">

  <h4>VIAJE TERMINADO</h4>

  <button class="btn btnClose" (click)="close()">
    <img src="assets/img/icoClose.svg">
  </button>

  <div class="headInfo terminado">
    <div class="servicio">
      <span>SERVICIO</span>
      <h4>{{viaje?.servicio}}</h4>
    </div>
    <div class="item">
      <span>ID VIAJE</span>
      <p>{{viaje?.viajeCodigo}}</p>
    </div>
    <div class="item">
      <span>INICIO</span>
      <p>{{muestraHora(viaje?.fechahoraInicio)}} <span class="clRed">+10m</span></p>
    </div>
    <div class="item">
      <span>ORIGEN</span>
      <p>{{viaje?.sucursalOrigen.nombre}}</p>
    </div>
    <div class="item">
      <span>SENTIDO</span>
      <p>{{viaje?.sentido}}</p>
    </div>
    <div class="item">
      <span>DESTINO</span>
      <p>{{viaje?.sucursalDestino.nombre}}</p>
    </div>
    <div class="item">
      <span>LLEGADA</span>
      <p>{{muestraHora(detalleViaje?.fechahoraLlegada)}} <span
          *ngIf="detalleViaje?.fechahoraLlegada">{{muestraDiferenciaHorasMinutos(detalleViaje?.fechahoraTermino,
          detalleViaje?.fechahoraLlegada)}}</span></p>
    </div>
  </div>


  <div class="contBoxes">

    <div class="box vehiculo">

      <div class="rowItems">
        <div class="item">
          <span>ID BUS</span>
          <p>{{viaje?.movil.numeroInterno}}</p>
        </div>
        <div class="item">
          <span>PATENTE</span>
          <p>{{viaje?.movil.patente}}</p>
        </div>
        <div class="item">
          <span>TIPO DE BUS</span>
          <p>{{viaje?.movil.tipoMovil?.codigo}}</p>
        </div>
        <div class="item">
          <span>COMBUSTIBLE I.</span>
          <p>{{detalleViaje?.movil.estadoInicio?.capacidadPorcentaje}}%</p>
        </div>
        <div class="item">
          <span>% COMBUSTIBLE FINAL</span>
          <p>{{detalleViaje?.movil.estadoTermino?.capacidadPorcentaje}}%</p>
        </div>
      </div>

      <div class="boxAccion mt-3">
        <ng-container
          *ngIf="detalleViaje?.movil.estado == 'DISPONIBLE' || detalleViaje?.movil.estado == 'EN_CURSO'"><img
            src="assets/img/icoPatio.svg"> DISPONIBLE</ng-container>
        <ng-container *ngIf="detalleViaje?.movil.estado == 'EN_LAVADO'"><img src="assets/img/icoLavado.svg"> LLEVAR A
          LAVADO</ng-container>
        <!--<ng-container *ngIf="detalleViaje?.movil.estado == 'EN_LAVADO'"><img src="assets/img/icoLavado.svg"> LLEVAR A LAVADO PROFUNDO</ng-container>-->
        <ng-container *ngIf="detalleViaje?.movil.estado == 'EN_TALLER'"><img src="assets/img/icoTaller.svg"> LLEVAR A
          TALLER</ng-container>
        <ng-container *ngIf="detalleViaje?.movil.estado == 'EN_CARGA'"><img src="assets/img/icoDieselRed.svg"> CARGAR
          COMBUSTIBLE/BATERÍA</ng-container>
        <!-- <ng-container *ngIf="detalleViaje?.movil.estado == 'NO_DISPONIBLE'"><img src="assets/img/icoNoDisponible.svg"> DEJAR NO DISPONIBLE</ng-container> -->
      </div>

      <!--<div class="boxAccion mt-3" style="color: var(--red)">
        <img src="assets/img/icoDieselRed.svg"> EN CARDA DE COMBUSTIBLE / ENERGÍA
      </div>-->
    </div>

    <div class="box conductor">
      <div class="rowItems">
        <div class="item">
          <span>ID CONDUCTOR</span>
          <p>{{viaje?.conductor.visibleId}}</p>
        </div>
        <div class="item">
          <span>NOMBRE CB</span>
          <p>{{viaje?.conductor.nombres}} {{viaje?.conductor.apellidoPaterno}}</p>
        </div>
        <div class="item">
          <span>HORAS DISPONIBLES</span>
          <p>{{mostraHorasDisponibles()}}</p>
        </div>
        <div class="item">
          <span>AUTDO / H. EXTRAS</span>
          <p>{{(viaje?.conductor.hhExtraAutorizadas) ? 'SI' : 'NO'}} /
            {{convertirMinutosEnHoras(viaje?.conductor.jornadaEnCurso?.horasExtra)}}</p>
        </div>
        <div class="item doble">
          <span>TERMINAL CONTRATO</span>
          <p>{{viaje?.conductor.contratoSucursal.nombre}}</p>
        </div>
      </div>

      <div class="boxAccion mt-3">
        <ng-container
          *ngIf="detalleViaje?.conductor.estado == 'DISPONIBLE' || detalleViaje?.conductor.estado == 'EN_CURSO'"><img
            src="assets/img/icoDisponible.svg"> DISPONIBLE</ng-container>
        <ng-container *ngIf="detalleViaje?.conductor.estado == 'CAPACITACION'"><img
            src="assets/img/icoCapacitacion.svg"> CAPACITACIÓN</ng-container>
        <ng-container *ngIf="detalleViaje?.conductor.estado == 'REVISION_TECNICA'"><img
            src="assets/img/icoRevisionTecnica.svg"> EN REVISIÓN TÉCNICA</ng-container>
        <ng-container *ngIf="detalleViaje?.conductor.estado == 'EN_PATIO'"><img src="assets/img/icoPatio.svg"> APOYO
          PATIO</ng-container>
        <ng-container *ngIf="detalleViaje?.conductor.estado == 'EN_COLACION'"><img src="assets/img/icoColacion.svg"> EN
          COLACIÓN</ng-container>
        <ng-container *ngIf="detalleViaje?.conductor.estado == 'EN_TALLER'"><img src="assets/img/icoTaller.svg">
          TRASLADO BUS A TALLER</ng-container>
        <ng-container *ngIf="detalleViaje?.conductor.estado == 'FUERA_JORNADA'"><img src="assets/img/icoFinJornada.svg">
          FUERA DE JORNADA</ng-container>
      </div>

      <!--<div class="boxAccion mt-3">
        <img src="assets/img/icoColacion.svg"> EN COLACIÓN <span>(30M)</span>
      </div>-->

      <button class="btn btnBlack mx-auto mt-3 d-block" [disabled]="procesandoPdf" (click)="getColacionPDF()"
        *ngIf="detalleViaje?.conductor.estado == 'EN_COLACION' && tienePermisoImprimirColacion()">IMPRIMIR</button>

    </div>

  </div>

</div>